(function () {
  var activated = false;
  var cartActivated = false;
  var cartOpenReplayScheduled = false;
  var cartOpenReplayInProgress = false;
  var cartOpenSelector = '.cart-open-trigger, .header__cart, [href="/cart"]';

  function loadScript(placeholder) {
    if (!placeholder || placeholder.getAttribute('data-eyesnug-app-loaded') === 'true') return;

    var source = placeholder.getAttribute('data-src');
    if (!source) return;

    placeholder.setAttribute('data-eyesnug-app-loaded', 'true');
    var script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.setAttribute('data-eyesnug-deferred-app-source', source);
    document.head.appendChild(script);
  }

  function restoreScripts(fragment) {
    fragment.querySelectorAll('script').forEach(function (script) {
      var replacement = document.createElement('script');
      Array.prototype.slice.call(script.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.textContent = script.textContent;
      script.replaceWith(replacement);
    });
  }

  function loadTemplate(template) {
    if (!template || template.getAttribute('data-eyesnug-app-loaded') === 'true') return;

    template.setAttribute('data-eyesnug-app-loaded', 'true');
    var fragment = template.content.cloneNode(true);
    restoreScripts(fragment);
    document.head.appendChild(fragment);
    template.remove();
  }

  function activateAll() {
    if (activated) return;
    activated = true;
    document.querySelectorAll(
      '[data-eyesnug-deferred-storefront-app-template]:not([data-eyesnug-cart-app])'
    ).forEach(loadTemplate);
    document.querySelectorAll(
      '[data-eyesnug-deferred-storefront-app]:not([data-eyesnug-cart-app])'
    ).forEach(loadScript);
  }

  function activateCartApps() {
    if (window.EyesnugNativeCartTemplate === true) return;
    if (cartActivated) return;
    cartActivated = true;
    if (window.EyesnugCandyRackGate) window.EyesnugCandyRackGate.activate();
    document.querySelectorAll(
      '[data-eyesnug-deferred-storefront-app-template][data-eyesnug-cart-app]'
    ).forEach(loadTemplate);
    document.querySelectorAll(
      '[data-eyesnug-deferred-storefront-app][data-eyesnug-cart-app]'
    ).forEach(loadScript);
  }

  function loadImmediateApps() {
    document.querySelectorAll('[data-eyesnug-deferred-storefront-app][data-eyesnug-load-immediately]').forEach(loadScript);
  }

  function scheduleCartOpenReplay(trigger) {
    if (!trigger || cartOpenReplayScheduled || cartOpenReplayInProgress) return;
    cartOpenReplayScheduled = true;

    var attempts = 0;
    var maximumAttempts = 80;

    function replayWhenReady() {
      if (!document.documentElement.contains(trigger)) {
        cartOpenReplayScheduled = false;
        return;
      }

      var wrapper = document.getElementById('candyrack-slider-cart-wrapper');
      if (wrapper) {
        var styles = window.getComputedStyle(wrapper);
        if (styles.display !== 'none' && styles.visibility !== 'hidden') {
          cartOpenReplayScheduled = false;
          return;
        }

        /*
         * The wrapper can be mounted before Candy Rack has attached its cart
         * icon click listener. Wait for the app's supported API instead of
         * replaying the header click, which also re-triggers the theme drawer.
         */
        if (typeof window.CandyRackSliderCart?.openCart === 'function') {
          cartOpenReplayInProgress = true;
          window.CandyRackSliderCart.openCart();
          cartOpenReplayInProgress = false;
          cartOpenReplayScheduled = false;
          return;
        }
      }

      attempts += 1;
      if (attempts >= maximumAttempts) {
        cartOpenReplayScheduled = false;
        return;
      }

      window.setTimeout(replayWhenReady, 50);
    }

    window.setTimeout(replayWhenReady, 75);
  }

  function bindIntent() {
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (eventName) {
      window.addEventListener(eventName, activateAll, { once: true, passive: true });
    });
  }

  function bindCartIntent() {
    var cartIntentSelector = [
      '.cart-open-trigger',
      '.header__cart',
      '[href="/cart"]',
      '[name="add"]',
      'form[action*="/cart/add"] [type="submit"]',
      '[data-type="add-to-cart-form"] [type="submit"]'
    ].join(',');

    function handleCartIntent(event) {
      if (window.EyesnugNativeCartTemplate === true) return;
      var target = event.target;
      if (!(target instanceof Element) || !target.closest(cartIntentSelector)) return;
      if (cartOpenReplayInProgress) return;

      var cartOpenTrigger = target.closest(cartOpenSelector);
      activateCartApps();

      /*
       * Verify every real cart-open intent. If Candy Rack handled it, its
       * wrapper will already be visible and no fallback runs. If the click was
       * consumed while the deferred app initialized, open through Candy Rack's
       * API as soon as that API is ready.
       */
      if (cartOpenTrigger && event.type !== 'focusin') {
        scheduleCartOpenReplay(cartOpenTrigger);
      }
    }

    document.addEventListener('pointerdown', handleCartIntent, { capture: true, passive: true });
    document.addEventListener('touchstart', handleCartIntent, { capture: true, passive: true });
    document.addEventListener('click', handleCartIntent, true);
    document.addEventListener('focusin', handleCartIntent, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') handleCartIntent(event);
    }, true);

    ['cart:updated', 'cart:refresh', 'product:added'].forEach(function (eventName) {
      document.addEventListener(eventName, activateCartApps, { once: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    loadImmediateApps();
    bindIntent();
    bindCartIntent();
  });

  window.addEventListener('load', function () {
    window.setTimeout(activateAll, 15000);
  }, { once: true });

  window.EyesnugDeferredStorefrontApps = {
    activateAll: activateAll,
    activateCartApps: activateCartApps,
    loadScript: loadScript,
    loadTemplate: loadTemplate
  };
})();
